module.exports = __webpack_public_path__ + "img/Loosduinsekade na.00442356.jpg";